module.exports = __webpack_public_path__ + "static/media/05.5a794004.webp";